import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ToastService } from 'src/app/common/service/toast.service';
import { UserProfileService } from 'src/app/common/service/user-profile.service';
import { SaveMode } from 'src/app/shared/model/save-mode';
import { SetOfFilters } from '../../../model/set-of-filters';
import { SetOfFiltersType } from '../../../model/set-of-filters-type';
import { SetsOfFiltersService } from '../../../service/sets-of-filters.service';

@Component({
  selector: 'app-set-of-filters-dialog',
  templateUrl: './set-of-filters-dialog.component.html',
  styleUrls: ['./set-of-filters-dialog.component.scss']
})
export class SetOfFiltersDialogComponent {

  isSubmitted: boolean = false;
  form: FormGroup;
  existingSetNames: string[];
  setOfFilters: SetOfFilters;
  saveMode: SaveMode;

  constructor(public dialogRef: MatDialogRef<SetOfFiltersDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
              public userProfileService: UserProfileService, private formBuilder: FormBuilder, private setsOfFiltersService: SetsOfFiltersService,
              private toastService: ToastService) {
    this.setOfFilters = this.data.setOfFilters;
    this.saveMode = this.data.saveMode;
    this.existingSetNames = data.existingSetNames;

    this.form = this.formBuilder.group({
      name: new FormControl(null, [Validators.required, this.uniqueNameValidator.bind(this), Validators.maxLength(100)]),
      type: new FormControl(null, [Validators.required])
    });
  }

  submit(): void {
    this.isSubmitted = true;
    this.dialogRef.disableClose = true;
    this.setOfFilters.name = this.form.value.name;
    this.setOfFilters.type = SetOfFiltersType[this.form.value.type];

    this.setsOfFiltersService.saveSetOfFilters(this.setOfFilters)
      .pipe(
        catchError(error => {
          this.isSubmitted = false;
          this.showError(error, 'saveSetOfFiltersError');
          return of<SetOfFilters>();
        }),
        tap(savedCriteria => this.dialogRef.close(savedCriteria))
      )
      .subscribe();
  }

  isSubmitDisabled(): boolean {
    return !this.form.valid || this.isSubmitted;
  }

  controlHasError(controlName: string, errorName: string): boolean {
    return this.form.get(controlName).hasError(errorName);
  }

  getSetOfFiltersTypesForUser(): string[] {
    if (this.userProfileService.isService())
      return Object.keys(SetOfFiltersType);
    return [Object.keys(SetOfFiltersType)[Object.values(SetOfFiltersType).indexOf(SetOfFiltersType.USER)]];
  }

  private uniqueNameValidator(nameControl: FormControl): ValidationErrors | null {
    if (nameControl.value && nameControl.valid) {
      const alreadyExists = this.existingSetNames.includes(nameControl.value);
      if (alreadyExists)
        return { nameExists: true };
    }
    return null;
  }

  private showError(errorToLog: any, errorToDisplay: string): void {
    console.error(errorToLog);
    this.toastService.showErrorToast(errorToDisplay);
  }
}
